class LanguageDropdownMenu {
    constructor(selector) {
        if (!selector) return;
        this.body = document.querySelector("body");
        this.container = document.querySelector(selector);
        if ( this.container === null ){
            return;  
        }          
        this.dropdown = this.container.querySelector(".c-dropdown-menu");
        this.init();
    }

    init() {
        this.container.addEventListener("click", (e) => this.toggle(e));
        this.dropdown.addEventListener("click", (e) => e.stopPropagation());
    }

    show() {
        if ( typeof window.avatarMenu === 'object' ){
            window.avatarMenu.hide();
        }
        if ( typeof window.searchBoxDesktop === 'object' ){
            window.searchBoxDesktop.hide();
        }
        this.dropdown.classList.remove("c-hidden");
    }

    hide() {
        this.dropdown.classList.add("c-hidden");
    }

    toggle(event) {
        event.stopPropagation();
        if (this.dropdown.classList.contains("c-hidden")) {
            this.show();
        }
        else {
            this.hide();
        }
    }
}


(function() {
    jQuery(document).ready(function () {
        //window.languageDropdownMenu = new LanguageDropdownMenu(".c-dropdown-menu-wrapper");
    });

    jQuery(document).on('tmModal_open_#c-language-modal', function () {
        if ( typeof window.languageDropdownMenu === 'object' ){
            window.languageDropdownMenu.hide();
        }
    });
})();

